<template>
  <basic-selects
    :hasSequence="hasSequence"
    :trigger="trigger"
    :isMultiple="isMultiple"
    :columns="columns"
    :items="onlineOrderItems"
    :title="`${$t('title.selectfood')}`"
    idProperty="OnlineOrderItemId"
    nameProperty="OnlineOrderItemName"
    allSelectId="onlineOrderItemAllSelectBox"
    @onSaved="onSaved"
    :id="id"
    :pagination="pagination"
    @getItems="getItems"
    sortBy="OnlineOrderItemNumber"
    :defaultItems="defaultItems"
    viewName="OnlineOrderItemSelects"
  ></basic-selects>
</template>

<script>
import basicSelects from "./BasicSelects";

export default {
  data() {
    return {
      onlineOrderItems: [],
      columns: [
        {
          name: "OnlineOrderItemName",
        },
      ],
      id: "onlineOrderItemSelectModal",
      pagination: {},
    };
  },
  props: {
    trigger: false,
    isMultiple: false,
    modalId: undefined,
    defaultItems: undefined,
    onlineOrderType: undefined,
    hasSequence: false,
  },
  watch: {
    modalId: {
      handler(value) {
        if (value) this.id = value;
      },
      immediate: true,
    },
    trigger() {
      this.getItems();
    },
  },
  components: {
    basicSelects,
  },
  methods: {
    onSaved(item) {
      this.$emit("onSaved", item);
    },
    getItems(dTO) {
      if (!this.onlineOrderType) {
        this.$func.message.alert("系統異常 !");
        return;
      }
      if (!dTO) {
        dTO = {};
      }
      dTO.type = this.onlineOrderType;
      const vm = this;
      this.$api.onlineOrderItems.getPages(dTO).then((data) => {
        vm.onlineOrderItems = data.Datas;
        vm.pagination = data.Pagination;
      });
    },
  },
};
</script>
